<template>
  <v-form v-bind="this.$attrs">
    <div class="wrap_filter">
      <v-row class="mb-0">
        <v-col cols="12" md="4" class="pb-0">
          <v-text-field ref="title" v-model="title" label="Tiêu đề" outlined required dense hide-details>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="pb-0">
          <v-text-field ref="description" v-model="description" label="Mô tả" outlined required dense hide-details>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="pb-0">
          <div class="mr-3 d-flex justify-end align-end">
            <v-btn class="search-button" height="40" outlined @click="onFilter"> Tìm kiếm </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
// TODO: filter with teacher
export default {
  name: 'SurveyFilter',
  data() {
    return { title: '', description: '' }
  },
  created() {
    this.fetch({ _start: 0, _limit: 10 })
    this.count()
  },
  methods: {
    ...mapActions({
      fetch: 'survey/fetch',
      count: 'survey/count'
    }),
    ...mapMutations({
      setState: 'survey/setState'
    }),
    async onFilter() {
      try {
        this.setState({ atr: 'loading', value: true })
        const params = {}
        if (this.title) params.title_contains = this.title
        if (this.description) params.description_contains = this.description

        await this.fetch({ ...params, _start: 0, _limit: 10 })
        await this.count(params)
        this.setState({ atr: 'query', value: params })
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.setState({ atr: 'loading', value: false })
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
